// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__IJgW2","content":"LayoutSettings_content__3B_cK"};